/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect"
export default {
    name: "File_FolderPopup",
    components: {

    },
    props: {

        list: {
            type: String,
            default: "",
        },
        source:
        {
            type: String,
            default: "",
        },
        projectId: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            roleList: [],
            permissionset: [],
            dataforsave: {
                "folderId": store.getters.getselectedFolder,
                "userPermission": []
            },
            userobject: {},
            multiuserobject: {},
            permissionList: [],
            selectedscreens: [],
            screensds: [],
            screenNames: [],
            controlName: [],
            baseApi: `${process.env.VUE_APP_Service_URL}`,
            baseurl: `${process.env.VUE_APP_Service_URL}document/folderfilepermission/`,
            baseapi: `${process.env.VUE_APP_Service_URL}configuration`,
            userList: [],
            // designationList: [],
            closemodal: false,
            selectedRole: [],
            Designation: [],
            selectedValue: [],
            folderPermissionList: [],
            permUserlist: [],
            permUser: "",
            showSave: false,
            fromPage: "",
        }
    },
    watch: {
        "$store.getters.getselectedFolder": function (val) {
            this.docId = store.getters.getselectedFolder
        },
    },
    async mounted() {
        this.idtoken = store.getters.getToken
        await this.ScreenRoles();
        this.fromPage = store.getters.getFromPage;
    },
    methods: {
        ScreenRoles() {
            const fromPage = store.getters.getFromPage;
            if (fromPage == "Department" || fromPage == 'generalFiles') {
                this.getalldesignation()
            }
            else {
                this.ListRoles()
            }
        },
        async getalldesignation() {
            await axios
                .get(`${this.baseapi}/designation/search?PageSize=10000&SortProperty=displayName`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.roleList = res.data.entities;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async ListRoles() {
            this.projId = await store.getters.getSelectedProject,
                console.log("SourceType", this.source)
            await axios
                .get(
                    `${this.baseApi}configuration/projectrole/getall?projectId=${this.projId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.roleList = res.data;
                })
                .catch((err) => {
                    console.log(err);
                    this.roleList = []
                })
        },

        async onChange(event) {
            this.showSave = true
            this.selectedRole = event.target.value;
            await this.SelectBothRoleUsers(this.selectedRole);
            this.permissionset = [];
        },
        async SelectBothRoleUsers(role) {
            const fromPage = store.getters.getFromPage;
            if (fromPage == "Department" || fromPage == 'generalFiles') {
                await this.getDesignationUsers();
            } else {
                await this.getProjectRoleUsers();
            }

        },
        async getDesignationUsers() {
            const idtoken = store.getters.getToken
            this.selectedValue = this.selectedRole;
            const fromPage = store.getters.getFromPage;
            if(fromPage == 'generalFiles'){
                store.dispatch("setMainDepartment",'')
            }
            await axios
                .post(`${this.baseurl}designationusers?departmentId=` + store.getters.getMainDepartment + "&folderId=" + this.list, [this.selectedValue], {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userList = res.data;
                    this.getAllFolderPermission();
                    this.setusersinarray();
                    this.getFolderPermissionbyId();

                })
                .catch((err) => {
                    console.log(err);
                });
        },

        async folderMultiSave() {

            let projId = store.getters.getSelectedProject;
            let savedata = {
                "folderId": this.list,
                "type": this.source,
                "department": this.projectId,
                "userPermission": Object.values(this.userobject)
            };
            console.log("Multi folder save", savedata)
            // let changedUsers = await this.compareAndSave(this.folderPermissionList, savedata);
            // if (changedUsers.length === 0) {
            //     alert('No changes in user permissions.');
            //  return;
            //   }
            //   else{
            await axios
                .post(`${this.baseApi}document/folder/share`, savedata
                    , {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    this.userListsss = res.data;
                    alert("Folder shared successfully");
                    this.close();
                })
                .catch((err) => {
                    console.log(err);
                });
            //}
        },

        // async compareAndSave(existingData, saveData) {
        //     const updatedUsers = [];

        //     // Loop through each user in saveData
        //     for (const user of saveData.userPermission) {
        //       // Find the matching user in existingData
        //       const existingUser = existingData.find(
        //         (u) => u.emailId === user.emailId && u.userId === u.userId
        //       );

        //       // If the user doesn't exist in existingData, check if the permission array is empty and skip to the next user
        //       if (!existingUser) {
        //         if (user.permission.length === 0) {
        //           continue;
        //         } else {
        //           // If the permission array is not empty, add the user to updatedUsers
        //           updatedUsers.push(user);
        //         }
        //       } else {
        //         // Compare the permissions
        //         const hasChanges = JSON.stringify(existingUser.permission) !== JSON.stringify(user.permission);

        //         // If there are changes, add the user data to updatedUsers
        //         if (hasChanges) {
        //           updatedUsers.push({
        //             emailId: user.emailId,
        //             userId: user.userId,
        //             permission: user.permission,
        //           });
        //         }
        //       }
        //     }

        //     console.log("updatedUsers",updatedUsers)
        //     return updatedUsers;
        //   },




        async getProjectRoleUsers(value) {
            this.selectedValue = this.selectedRole;
            await axios
                .post(`${this.baseapi}/userprojectrole/getusersbyrole?projectId=${this.projId}&folderId=${this.list}`,[this.selectedValue], {
                    headers: {
                        Authorization: "Bearer " + this.idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userList = res.data;
                    this.getAllFolderPermission();
                    this.setusersinarray();
                    this.getFolderPermissionbyId();

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async clearall() {
            this.selectedscreens = [];
            document.getElementById("selectall").checked = false;
            this.screensds = [];
            await this.screens.forEach((element) => {
                document.getElementById(element.id).checked = false;
                let savescreen = {
                    name: "",
                    controls: [],
                };
                savescreen.name = element.name;
                this.screensds.push(savescreen);
            });
        },
        async setusersinarray() {
            this.userobject = [];
            this.userList.forEach((eachusers) => {
                let userinformations = {
                    // "permissionType": "ProjectRole",
                    // "permissionId": this.selectedValue,
                    "userId": eachusers.userId,
                    "emailId": eachusers.emailId,
                    "name": eachusers.userName,
                    "permission": [],
                    "permissionId": this.selectedValue,
                    "permissionType": "ProjectRole"
                };
                this.userobject[eachusers.userId] = userinformations;

            });
        },
        async saveallfun() {
            const usersaveValues = Object.values(this.userobject);
        },
        async setcontrols(elements) {
            let checkBox = document.getElementById(elements.userId);
            if (checkBox.checked == true) {
                this.userobject[elements.userId].permission = this.permissionset;
                console.log("permmm", this.permissionset)

            } else {
                if (elements.userId in this.userobject) {
                    this.userobject[elements.userId].permission = [];
                }
            }
        },
        async setpermissions(permission) {
            let permissioncheckBox = document.getElementById(permission);
            if (permissioncheckBox.checked == true) {
                this.userList.forEach((users) => {
                    if (!this.userobject[users.userId].permission.includes(permission)) {
                        this.userobject[users.userId].permission.push(permission);
                    }
                })
            } else {
                this.userList.forEach((users) => {
                    if (this.userobject[users.userId].permission.includes(permission)) {
                        var index = this.userobject[users.userId].permission.indexOf(permission);
                        if (index !== -1) {
                            this.userobject[users.userId].permission.splice(index, 1);
                        }
                    }
                })
            }
        },
        async selectall() {
            let checkBoxall = document.getElementById("selectall");
            if (checkBoxall.checked == true) {
                this.userList.forEach((users) => {
                    this.userobject[users.userId].permission = this.permissionset;
                })
            } else {
                this.userList.forEach((users) => {
                    this.userobject[users.userId].permission = [];
                })
            }
        },
        async getAllFolderPermission() {
            await axios
                .get(`${this.baseurl}allfolderpermission`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    this.permissionList = res.data;

                    this.setofpermissions();
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        setofpermissions() {
            this.permissionList.forEach((permissions) => {
                this.permissionset.push(permissions.permission);
            })
        },
        selectuserwithpermission(userid) {
            let checkBox = "";
            checkBox = document.getElementById(userid);
            if ((this.userobject[userid].permission).length != 0) {
                checkBox.checked = true;
            }
        },
        async getFolderPermissionbyId() {
            await axios
                .post(`${this.baseurl}getfolderpermissions?FolderId=${this.list}`,[this.selectedValue],
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    this.folderPermissionList = res.data;
                    this.retrievePermission();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async retrievePermission() {
            await this.folderPermissionList.forEach((element) => {
                this.userobject[element.userId].permission = element.permission;
            });
        },

        close() {
            this.$emit('closemodal')
            store.dispatch("setfileType", '')
        }
    }
}
